<template>
  <div class="inner-content">
    <template v-if="!giftingEnabled">
      <UiEmpty tip="敬请期待！" hook="vh" />
    </template>
    <template v-else>
      <div class="center">
        <div class="wrap" :style="{ transform: `scale(${scale * 0.95})` }">
          <div class="wawa">
            <div class="btn gotoGift" @click="gotoGift">
              <div class="label-box">
                <span class="label-shadow">前往送礼</span>
                <span class="label-text">前往送礼</span>
              </div>
            </div>
          </div>
          <div class="bg"></div>
          <div class="center-box">
            <div v-show="loginTasks" v-for="(item, index) in loginTasks" :key="index" class="center-item">
              <div class="bg">
                <div class="rewards" @click="handleDedicate(item, 'rewards')">
                  <div class="num">{{ getNum(index) }}</div>
                  <div class="stage" :style="{ backgroundImage: 'url(' + item.imgUrl + ')' }"></div>
                  <div class="describe">
                    <div class="quantities">
                      <div class="label-box">
                        <span class="label-shadow">{{ item.desc }}x {{ item.coins }}</span>
                        <span class="label-text">{{ item.desc }}x {{ item.coins }}</span>
                      </div>
                    </div>
                  </div>
                  <div v-if="item.status === 0" class="mask"></div>
                  <div class="status" :class="getPickupStatus(item.status)"></div>
                </div>
                <div v-show="sendTasks" class="accrue" @click="handleDedicate(sendTasks[index], 'accrue')">
                  <div class="num">{{ getNum(index) }}</div>
                  <div class="stage-accrue" :style="{ backgroundImage: 'url(' + sendTasks[index].imgUrl + ')' }"></div>
                  <div class="describe">
                    <div class="quantities">
                      <div class="label-box">
                        <span class="label-shadow">{{ sendTasks[index].desc }}x{{ sendTasks[index].coins }}</span>
                        <span class="label-text">{{ sendTasks[index].desc }}x{{ sendTasks[index].coins }}</span>
                      </div>
                    </div>
                  </div>
                  <div v-if="sendTasks[index].status === 0" class="mask"></div>
                  <div class="status" :class="getPickupStatus(sendTasks[index].status)"></div>
                </div>
                <div class="stage-describe" :class="{ active: sendTasks[index].status !== 0 }">
                  <div class="stage-text">
                    <div class="label-box">
                      <span class="label-shadow">{{ sendTasks[index].title }}</span>
                      <span class="label-text">{{ sendTasks[index].title }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="progress">
            <div class="white">
              <div class="dian">
                <div class="dian-center" v-for="n in 8" :key="n">
                  <div class="dian-white"></div>
                </div>
              </div>
            </div>
            <div class="yellow" :style="{ width: getWidth(isNumber) }"></div>
            <div class="gut">
              <div v-show="isNumber" class="element" v-for="(item, index) in isNumber" :key="index">
                <div class="chang"></div>
              </div>
            </div>
          </div>
          <div class="mission-progress">
            <div class="label-box progress-text">
              <span class="label-shadow">累计给任意战队赠送礼物：</span>
              <span class="label-text">累计给任意战队赠送礼物：</span>
            </div>
            <div class="label-box progress-num">
              <span class="label-shadow">{{ personsRedu }}/30000</span>
              <span class="label-text">{{ personsRedu }}/30000</span>
            </div>
          </div>
        </div>

      </div>
    </template>

  </div>
</template>

<script setup>
import { ref, computed, watch } from 'vue'
import { useRouter } from 'vue-router'
import { useAppStore, useStageStore } from '@/store'
import * as api from '@/service/index'
import { usePrompt } from '@/composables/usePrompt'
import UiEmpty from '@/components/ui-empty'

defineOptions({ name: 'Dedicate' })

const router = useRouter()

const appStore = useAppStore()
const stageStore = useStageStore()

// 登录奖励
const loginTasks = ref([])
// 贡献奖励
const sendTasks = ref([])
const inRequest = ref(false)
const isNumber = ref(0)
const personsRedu = ref(0)
const hasInitDedicateData = ref(false)
// timeImg: [
//   'https://website.xdcdn.net/poster/355916/sausage-match/FMOATHfR.png',
//   'https://website.xdcdn.net/poster/355916/sausage-match/FMOCp6WJ.png',
//   'https://website.xdcdn.net/poster/355916/sausage-match/FMOE1YK1.png',
//   'https://website.xdcdn.net/poster/355916/sausage-match/FMOEGLrQ.png',
//   'https://website.xdcdn.net/poster/355916/sausage-match/FMOFaIUM.png',
//   'https://website.xdcdn.net/poster/355916/sausage-match/FMOFkWpf.png',
//   'https://website.xdcdn.net/poster/355916/sausage-match/FMOFkELW.png',
//   'https://website.xdcdn.net/poster/355916/sausage-match/FMOFkx4Y.png'
// ]

const { showPrompt } = usePrompt()

const token = computed(() => appStore.token)
const giftingEnabled = computed(() => stageStore.giftingEnabled)
const scale = computed(() => appStore.scale)

function initDedicateData() {
  if (hasInitDedicateData.value || !giftingEnabled.value || !token.value) {
    return
  }
  hasInitDedicateData.value = true
  fetchActivityList()
  reduPersonalRanking()
}
function getNum(index) {
  return index < 10 ? '0' + (index + 1) : index + 1
}
function getPickupStatus(activeStatus) {
  switch (activeStatus) {
    // 状态，0未完成 1已完成 2已领取
    case 0: return "unlocked";
    case 1: return "locked";
    case 2: return "received";
    default:
      break;
  }
}
// 统计已领取的数量
function getCount(tasks) {
  isNumber.value = 0
  for (let index = 0; index < tasks.length; index++) {
    const element = tasks[index];
    if (element.status === 1 || element.status === 2) {
      isNumber.value += 1
    }
  }
}
function getWidth(num) {
  if (num === 1) {
    return `${100 / 8 * (num / 2)}%`;
  } else if (num === 8) {
    return `${100 / 8 * num}%`;
  } else {
    return `${100 / 8 * num - (100 / 16)}%`;
  }
}
async function fetchActivityList() {
  if (!token.value) return;
  try {
    const res = await api.getActivityList({ token: token.value, taskType: 2 })
    if (res.status === 200) {
      const { loginTasks: loginTasksData, sendTasks: sendTasksData } = res.data
      loginTasks.value = loginTasksData;
      sendTasks.value = sendTasksData
      getCount(sendTasks.value)
    }
  } catch (err) {
    console.log(err)
  }
}
function formatDay(time) {
  // const isoDateString = time.replace(" ", "T");
  let dateObj = new Date(time);
  let month = dateObj.getMonth() + 1;
  month = month < 10 ? "0" + month : month;
  let day = dateObj.getDate();
  day = day < 10 ? "0" + day : day;
  return `${month}月${day}日`;
}

async function handleDedicate(value, type) {
  // console.log(value)
  if (!inRequest.value) {
    inRequest.value = true
    if (value.status === 0) {
      showPrompt('未完成,请再接再厉~');
    } else if (value.status === 1) {
      let data = {
        taskId: value.id
      }
      if (!token.value) return;
      try {
        let response = await api.getActivityReward(token.value, data)
        if (response.status === 200 && response.data === true) {
          const tapdbTetx = type === 'rewards' ? "登录奖励" : "贡献奖励"
          fetchActivityList()
          // 红点状态

          appStore.reqRedDotState()
          const now = await api.reqcurrentTime()
          if (value.isSend) {
            if (!token.value) return;
            await api.reqGiftList({ token: token.value, force: true })
          }
          showPrompt('领取成功～')

          if (now.status === 200) {
            const countdown = formatDay(now.data)
            if (typeof tapdb === 'undefined') return;
            // 领取任务奖励
            tapdb.trackEvent(tapdbTetx, {
              '#mission_unique_id': value.id + "+" + countdown,
              // 道具数量
              '#item_gain': value.coins,
              // 道具id
              '#prop_id': value.id,
              // 获得道具原因
              '#via_type': "累计人气贡献"
            });
          }
        }
      } catch (err) {
        console.log(err)
      }
    } else {
      showPrompt('已领取~');
    }
  }
  inRequest.value = false
}
// 获取个人送热度
async function reduPersonalRanking() {
  if (!token.value) return;
  try {
    let { status, data } = await api.getPersonalRanking(token.value)
    if (status === 200) {
      personsRedu.value = data.personal?.popularity
    }
  } catch (err) {
    console.log(err)
  }
}
function gotoGift() {
  router.push({
    name: 'Live',
    query: {
      is_send: true
    }
  })
}

watch(token, () => {
  initDedicateData()
}, { immediate: true })

watch(giftingEnabled, () => {
  initDedicateData()
}, { immediate: true })
</script>

<style lang="scss" scoped>
@import "./index";
</style>
